<template>
<div class="tags is-rounded has-addons">
  <span class="tag is-rounded">Risk Level</span>
  <span class="tag is-rounded" :class="{
    'is-warning': level === 'low',
    'is-strong-warning': level === 'medium',
    'is-danger': level === 'high' || level === 'critical'
  }">
  {{ level | ucwords }}
  </span>  
</div>

</template>
<script>
export default {
  
  props: {
    level: {
      type: String,
      required: true
    }
  }

}
</script>